export const Z_INDEX_HEADER_SEARCH = 1;
export const Z_INDEX_HEADER_SEARCH_OPEN = Z_INDEX_HEADER_SEARCH + 8;
